import React from 'react'

import { Container } from './styles'

import logoImage from '../../assets/logo-serpros.png'
import logosermais from '../../assets/logoSer.png'

const Logo: React.FC = () => {
  return (
    <Container>
      <img src={logoImage} alt="Serpros" />
      <img src={logosermais} alt="Ser+" />
    </Container>
  )
}

export default Logo
